import { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import { Menu, X } from "lucide-react"
import { Button } from "./ui/button"

export default function Navbar() {
  const location = useLocation()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Websites", path: "/websites" },
    { name: "Bonuses", path: "/bonuses" },
    { name: "Best Cases", path: "/best-cases" },
    { name: "Giveaways", path: "/giveaways" },
    { name: "FAQ", path: "/faq" },
  ]

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-all duration-300 ${
        scrolled ? "border-[#2A2D31]/50 bg-[#0A0C10]/80 backdrop-blur-md" : "border-transparent bg-transparent"
      }`}
    >
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <div className="flex items-center gap-2">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="relative">
              <img src="/images/websitelogo/CaseRTP.svg" alt="CaseRTP logo" className="h-12 w-12 object-contain" />
              <div className="absolute"></div>
            </div>
            <span className="text-xl font-bold font-display">CaseRTP</span>
          </Link>
        </div>

        <nav className="hidden md:flex items-center gap-6">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium transition-all duration-300 hover:text-[#FF6B00] relative ${
                location.pathname === item.path ? "text-[#FF6B00]" : "text-white"
              }`}
            >
              {item.name}
              {location.pathname === item.path && (
                <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-gradient-to-r from-[#FF6B00] to-[#FF9A3D]"></span>
              )}
            </Link>
          ))}
        </nav>

        <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </Button>
      </div>

      {isMenuOpen && (
        <div className="md:hidden border-t border-[#2A2D31]/50 bg-[#0A0C10]/95 backdrop-blur-md">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-3 text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? "bg-[#1A1D21]/50 text-[#FF6B00]"
                    : "text-white hover:bg-[#1A1D21]/30"
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  )
}
